import React from 'react'
import PropTypes from 'prop-types'

class LinkTr extends React.Component {
  render() {
    return(
      <tr>
        <th className={this.props.fieldClassName}>
          {this.props.fieldName}
        </th>
        <td>
          {this.props.fieldURL ? (
            <a className='styled-link pointer-hand'
               href={this.props.fieldURL}>
              {this.props.fieldValue}
            </a>
          ) : (
            '-'
          )}
        </td>
      </tr>
    )
  }
}

LinkTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldURL: PropTypes.string,
  fieldClassName: PropTypes.string
}

export default LinkTr
